import axios from 'axios';
import config from '../config';

// export const baseUrl = 'http://localhost:3000';
export const baseUrl =
  window.location.hostname === 'localhost'
    ? config.DEV.BE_URL
    : config.PROD.BE_URL;

export const Post = async (url, data, credentials) => {
  try {
    console.log('Post URL:', credentials, url, data);
    const response = await axios.post(url, data, {
      headers: { Authorization: credentials },
    });
    return response.data;
  } catch (error) {
    // Error(error.response.data.message);
    throw error;
  }
};

export const Get = async (url, credentials, queryParams) => {
  try {
    const response = await axios.get(url, {
      headers: { Authorization: credentials },
      params: queryParams,
    });
    return response.data;
  } catch (error) {
    console.log(error);
    // throw error
  }
};

export const Put = async (url, data, credentials) => {
  try {
    const response = await axios.put(url, data, {
      headers: { ...{ Authorization: credentials } },
    });
    return response.data;
  } catch (error) {
    // Error(error.response.data.message);
    throw error;
  }
};

export const Delete = async (url, credentials) => {
  try {
    const response = await axios.delete(url, {
      headers: { ...{ Authorization: credentials } },
    });
    return response.data;
  } catch (error) {
    // Error(error.response.data.message);
    throw error;
  }
};
